import { render, staticRenderFns } from "./underG.vue?vue&type=template&id=4726f738&scoped=true&"
import script from "./underG.vue?vue&type=script&lang=js&"
export * from "./underG.vue?vue&type=script&lang=js&"
import style0 from "./underG.vue?vue&type=style&index=0&id=4726f738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4726f738",
  null
  
)

export default component.exports